import { Component, OnInit, ViewChild } from '@angular/core';
import { FornecedorEstrutura } from '../models/fornecedor-estrutura';
import { Filtro } from '../models/filtro';
import { MatPaginator, MatDialog, PageEvent } from '@angular/material';
import { FornecedorEstruturaService } from '../services/fornecedor-estrutura.service';
import { UtilitarioService } from '../services/utilitario.service';
import { GlobalService } from '../services/global.service';
import { Router } from '@angular/router';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { CadastrarFornecedorEstruturaModalComponent } from '../modals/cadastrar-fornecedor-estrutura-modal/cadastrar-fornecedor-estrutura-modal.component';
import { FornecedoresEstrutura } from '../models/fornecedores-estrutura';
import swal from 'sweetalert2';
import { PaginatorService } from '../services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-fornecedor-estrutura',
  templateUrl: './fornecedor-estrutura.component.html',
  styleUrls: ['./fornecedor-estrutura.component.scss']
})
export class FornecedorEstruturaComponent implements OnInit {

  fornecedoresFiltrados: FornecedorEstrutura[] = [];
  carregando = true;
  campoOrdenacao = 'nome';
  ordenarDesc = false;
  editavel = true;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private fornecedorEstruturaService: FornecedorEstruturaService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private dialog: MatDialog,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarFornecedores();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarFornecedores();
    this.paginator.firstPage();
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscaFornecedores');
    this.carregando = true;

    this.fornecedorEstruturaService.consultarComPaginacao(
      this.paginacao.paginaAtual,
      this.itensPorPagina,
      this.campoOrdenacao,
      this.ordenarDesc ? 'desc' : 'asc',
      this.filtroNome.Valor,
    ).subscribe(dados => {
      this.fornecedoresFiltrados = dados.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      this.carregando = false;
      this.carregandoService.esconde('buscaFornecedores');
    }, (erro) => {
      this.carregandoService.esconde('buscaFornecedores');
      this.notificacaoService.erro(erro);
    });
  }

  novoFornecedor() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarFornecedorEstruturaModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.buscarFornecedores();
        }
      }
    )
  }

  editarFornecedor(fornecedor: FornecedorEstrutura) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarFornecedorEstruturaModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        idFornecedor: fornecedor.id
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.buscarFornecedores();
        }
      }
    )
  }

  excluirFornecedor(fornecedor: FornecedorEstrutura) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Fornecedor?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirFornecedor');
        this.fornecedorEstruturaService.excluir(fornecedor.id).subscribe(resp => {

          this.notificacaoService.sucesso('Fornecedor excluído com sucesso!!!');
          this.carregandoService.esconde('excluirFornecedor');
          this.filtra();
        }, (erro) => {
          this.carregandoService.esconde('excluirFornecedor');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFornecedores();
  }

  ngOnDestroy(): void {}
}